// src/components/CanonicalLinkPortal.js
// (Keep the code from the previous example)
import React, { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

const CanonicalLinkPortal = ({ href }: any) => {
    const realizedHref = useMemo(() => {
        if (href.indexOf(":") > -1) {
            return window.location.pathname;
        } else {
            return href
        }
    }, [href, window.location])

    useEffect(() => {
        const head = document.head;
        if (!head) return;

        const links = head.querySelectorAll('link[rel="canonical"]');
        let foundCorrectLink = false;

        links.forEach(link => {
            const current = link.getAttribute('href');

            if ((current == realizedHref || current.endsWith(realizedHref)) && !foundCorrectLink) {
                foundCorrectLink = true;
            } else {
                head.removeChild(link);
            }
        });
    }, [href]);

    if (typeof document === 'undefined' || !document.head) {
        return null;
    }

    return ReactDOM.createPortal(
        <link rel="canonical" href={`${window.location.origin}${realizedHref}`} key={href} data-managed-by="CanonicalLinkPortal" />,
        document.head
    );
};

export default CanonicalLinkPortal;